import { useMemo } from 'react';
import type { SeoDefinition } from '../calculators/types';
import { useSeo } from '../seo/seo';
import { buildProductStructuredData } from '../seo/structuredData';

export function ProductSeo({ seo }: Readonly<{ seo: SeoDefinition }>) {
  const structuredData = useMemo(() => buildProductStructuredData(seo), [seo]);
  useSeo(seo, structuredData);
  return null;
}
